exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".edit-sub-pause .pause-wrap >p[data-v-f00d7ccc] {\n  padding: 1em 0;\n}\n.edit-sub-pause .pause-wrap hr[data-v-f00d7ccc] {\n  max-width: 22em;\n  margin: auto;\n  border-color: #ebebeb;\n}\n.edit-sub-pause .next-date[data-v-f00d7ccc] {\n  padding-top: 2em;\n}\n.edit-sub-pause .other-option[data-v-f00d7ccc] {\n  padding: 1em 1em 2.6em;\n}\n", ""]);

// exports
